import {
  Box,
  CloseIcon,
  IconButton,
  type IconButtonProps,
  Row,
  Spinner,
  Tooltip,
} from "@hightouch/htui";

interface LoadingWithHoverCancelProps {
  onCancel: () => void;
  iconButtonSize?: IconButtonProps["size"];
}

export const LoadingWithHoverCancel = (props: LoadingWithHoverCancelProps) => {
  const { onCancel, iconButtonSize } = props;
  return (
    <Row
      justifyContent="center"
      width="32px"
      _hover={{
        ".hovered": { display: "block" },
        ".unhovered": { display: "none" },
      }}
    >
      <Box className="unhovered" display="block" as={Spinner} size="sm" />
      <Row
        className="hovered"
        display="none"
        justifyContent="center"
        sx={{
          button: {
            color: "danger.base",
            _hover: { color: "danger.base" },
          },
        }}
      >
        <Tooltip message="Cancel query" placement="top">
          <IconButton
            aria-label="Cancel query"
            icon={CloseIcon}
            mr={2}
            size={iconButtonSize}
            onClick={onCancel}
          />
        </Tooltip>
      </Row>
    </Row>
  );
};
